import { render } from "./BottomClaim.vue?vue&type=template&id=975124f0"
import script from "./BottomClaim.vue?vue&type=script&lang=js"
export * from "./BottomClaim.vue?vue&type=script&lang=js"

import "./BottomClaim.vue?vue&type=style&index=0&id=975124f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__